module.exports = "/dist/fonts/Roboto-Medium.58aef543.ttf";